// Авторизация
function ajaxSignIn(jqForm) {
	var dataToSend = false;

	trimFormFields(jqForm);
	dataToSend = jqForm.serialize();

	// console.log(dataToSend);

	$.ajax({
		data: dataToSend,
		url: '/signin/',
		method: "POST",

		success: function(response) {
			var responseObj = JSON.parse(response);

			// console.log(responseObj);

			if (responseObj.status == true) {
				location.reload();
			}
			else {
				if (responseObj.error.message) showNotification(responseObj.error.message, 'error');
			}
		}
	});
}


// Регистрация
function ajaxSignUp(jqForm) {
	var dataToSend = false;

	trimFormFields(jqForm);
	dataToSend = jqForm.serialize();

	// console.log(dataToSend);

	$.ajax({
		data: dataToSend,
		url: '/signup/',
		method: "POST",

		success: function(response) {
			var responseObj = JSON.parse(response);

			// console.log(responseObj);

			if (responseObj.status == true) {
				var email = jqForm.find('input[name="email"]').val(),
					phone = jqForm.find('input[name="phone"]').val(),
					form = $('form.confirm-code');

				phone = phone.substr(0, 9) + '*** ** ' + phone.substr(-2);

				form.find('input[name="email"]').val(email);
				form.find('.get-confirm-code-button, .submit-form').data('action', 'signup');
				$('.body-cover-pop-up-wrapper.confirm-code .code-description span').html(phone);
				showPopUp('confirm-code');
				startConfirmCodeTimer();
			}
			else {
				if (responseObj.error.message) showNotification(responseObj.error.message, 'error');
			}
		}
	});
}


// Отправка кода подтверждения при регистрации
function ajaxSignUpSendConfirmCode(jqForm) {
	var dataToSend = 'action=send_confirm_code&';

	trimFormFields(jqForm);
	dataToSend += jqForm.serialize();

	// console.log(dataToSend);

	$.ajax({
		data: dataToSend,
		url: '/signup/',
		method: "POST",

		success: function(response) {
			var responseObj = JSON.parse(response);

			// console.log(responseObj);

			if (responseObj.status == true) {
				location.reload();
			}
			else {
				if (responseObj.error.message) showNotification(responseObj.error.message, 'error');
			}
		}
	});
}


// Отправка повторного запроса на получение кода при регистарции
function ajaxSignUpGetConfirmCode(jqForm) {
	var dataToSend = 'action=get_confirm_code&';

	trimFormFields(jqForm);
	dataToSend += jqForm.serialize();

	// console.log(dataToSend);

	$.ajax({
		data: dataToSend,
		url: '/signup/',
		method: "POST",

		success: function(response) {
			var responseObj = JSON.parse(response);

			// console.log(responseObj);

			if (responseObj.status == true) {
				showNotification(responseObj.result.message, 'success');
				startConfirmCodeTimer();
			}
			else {
				if (responseObj.error.message) showNotification(responseObj.error.message, 'error');
			}
		}
	});
}


// Восстановление пароля
function ajaxPasswordRecovery(jqForm) {
	var dataToSend = false;

	trimFormFields(jqForm);
	dataToSend = jqForm.serialize();

	// console.log(dataToSend);

	$.ajax({
		data: dataToSend,
		url: '/password-recovery/',
		method: "POST",

		success: function(response) {
			var responseObj = JSON.parse(response);

			// console.log(responseObj);

			if (responseObj.status == true) {
				showNotification(responseObj.result.message, 'success');
				hidePopUps();
				jqForm[0].reset();
			}
			else {
				if (responseObj.error.message) showNotification(responseObj.error.message, 'error');
			}
		}
	});
}


// Установка нового пароля
function ajaxSetNewPassword(jqForm) {
	var dataToSend = false;

	trimFormFields(jqForm);
	dataToSend = jqForm.serialize();

	// console.log(dataToSend);

	$.ajax({
		data: dataToSend,
		url: '',
		method: "POST",

		success: function(response) {
			var responseObj = JSON.parse(response);

			// console.log(responseObj);

			if (responseObj.status == true) {
				setNotificationCookie(responseObj.result.message, 'success');
				location = responseObj.result.json.url;
			}
			else {
				if (responseObj.error.message) showNotification(responseObj.error.message, 'error');
			}
		}
	});
}


// Поисквый запрос instant search
function ajaxInstantSearch(jqForm) {
	var csrfmiddlewaretoken = getCookie('csrftoken'),
		q = $.trim(jqForm.find('input[name="q"]').val()),
		dataToSend = 'csrfmiddlewaretoken=' + csrfmiddlewaretoken + '&q=' + q;

	// console.log(dataToSend);

	$.ajax({
		data: dataToSend,
		url: '/instant-search/',
		method: "POST",

		success: function(response) {
			var responseObj = JSON.parse(response);

			// console.log(responseObj);

			if (responseObj.status == true) {
				var container = jqForm.find('.search-suggestions-wrapper'),
					html = jqForm.find('.js-template').html();

				container.find('.search-suggestion-container').empty().remove();

				responseObj.result.json.list.forEach(function(suggestion) {
					container.append(html);
					container.find('a:last').attr('href', suggestion.url).find('span:first').html(suggestion.title).parent().find('span:last').html(suggestion.type);
				});
			}
			else {
				var container = jqForm.find('.search-suggestions-wrapper');

				container.find('.search-suggestion-container').empty().remove();

				if (responseObj.error.message) showNotification(responseObj.error.message, 'error');
			}
		}
	});
}


// Отправка отзыва
function ajaxSendReview(jqForm) {
	var dataToSend = false;

	trimFormFields(jqForm);
	dataToSend = jqForm.serialize();

	// console.log(dataToSend);

	$.ajax({
		data: dataToSend,
		url: '',
		method: "POST",

		success: function(response) {
			var responseObj = JSON.parse(response);

			// console.log(responseObj);

			if (responseObj.status == true) {
				jqForm.find('textarea[name="text"]').val('');
				showNotification(responseObj.result.message, 'success');
			}
			else {
				if (responseObj.error.message) showNotification(responseObj.error.message, 'error');
			}
		}
	});
}


// Отправка комментария к статье
function ajaxSendComment(jqForm) {
	var dataToSend = false;

	trimFormFields(jqForm);
	dataToSend = jqForm.serialize();

	// console.log(dataToSend);

	$.ajax({
		data: dataToSend,
		url: '',
		method: "POST",

		success: function(response) {
			var responseObj = JSON.parse(response);

			// console.log(responseObj);

			if (responseObj.status == true) {
				location.hash = '#comment' + responseObj.result.json.comment_id;
				location.reload();
			}
			else {
				if (responseObj.error.message) showNotification(responseObj.error.message, 'error');
			}
		}
	});
}


// Infinity Loader
function ajaxInfinityLoader(jqButton) {
	var button = jqButton,
		buttonContainer = button.parents('.infinity-loader-button-container'),
		container = button.parents('.infinity-loader-container'),
		itemsContainer = container.find('.infinity-loader-items-container'),
		type = container.data('type') ? container.data('type') : undefined,
		nextPage = button.data('current-page') ? button.data('current-page') + 1 : 2,
		csrfmiddlewaretoken = getCookie('csrftoken'),
		dataToSend = "action=infinity_loader&page=" + nextPage + "&csrfmiddlewaretoken=" + csrfmiddlewaretoken + window.location.search.replace(/^\?/, '&');

	if (type) dataToSend += "&type=" + type;

	// console.log(dataToSend);

	$.ajax({
		data: dataToSend,
		url: '',
		method: "POST",

		success: function(response) {
			var responseObj = JSON.parse(response);

			// console.log(responseObj);

			if (responseObj.status == true) {
				itemsContainer.append(responseObj.result.html);

				if (responseObj.result.json.last) buttonContainer.empty().remove();
				else button.data('current-page', nextPage).removeClass('loading');
			}
			else {
				button.removeClass('loading');
				if (responseObj.error.message) showNotification(responseObj.error.message, 'error');
			}
		}
	});
}